import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Auth0Guard } from '@lib/auth0';
import { PosEnumResolverService } from '../services/pos-enum-resolver.service';
import { UserRolesResolve } from '../user';
import { CoreLayoutComponent } from './components/core-layout/core-layout.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LeadDetailComponent } from './components/lead-detail/lead-detail.component';
import { LoanPurposeComponent } from './components/loan-purpose/loan-purpose.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { SelectLoanComponent } from './components/select-loan/select-loan.component';
import { AppSubmittedCheckGuard } from './guards/app-submitted-check.guard';
import { LeadGuard } from './guards/lead.guard';
import { LoanSelectorGuard } from './guards/loan-selector.guard';
import { LoanResolverService } from './services/loan-resolver.service';
import { LookupResolverService } from './services/lookup-resolver.service';
import { PipelineDataResolver } from './services/pipeline-data.resolver';
import { PosConfigResolverService } from './services/pos-config-resolver.service';
import { Portal } from '@global/constants';

export const coreRoutes: Routes = [
  {
    path: '',
    canActivate: [Auth0Guard],
    resolve: { loans: UserRolesResolve },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'app' },
      {
        path: 'app',
        component: CoreLayoutComponent,
        data: { context: Portal.POS },
        resolve: {
          posOrgConfig: PosConfigResolverService,
          enumerations: PosEnumResolverService,
          lookups: LookupResolverService,
          parsedStages: PipelineDataResolver
        },
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'select-loan' },
          {
            path: 'select-loan',
            component: SelectLoanComponent,
            canActivate: [LoanSelectorGuard]
          },
          {
            path: 'loan-purpose',
            component: LoanPurposeComponent
          },

          {
            path: 'leads/:leadId',
            component: LeadDetailComponent,
            canActivate: [LeadGuard]
          },
          {
            path: ':loanId',
            component: LayoutComponent,
            resolve: { loan: LoanResolverService },
            children: [
              { path: '', redirectTo: 'application', pathMatch: 'full' },
              {
                path: 'application',
                canActivate: [AppSubmittedCheckGuard],
                loadChildren: () => import('../application/application.module').then((m) => m.ApplicationModule)
              },
              {
                path: 'tasks',
                canActivate: [AppSubmittedCheckGuard],
                loadChildren: () => import('../tasks/tasks.module').then((m) => m.TasksModule)
              },
              {
                path: 'my-profile',
                component: MyProfileComponent
              }
            ]
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(coreRoutes)],
  exports: [RouterModule]
})
export class CoreRoutingModule {}
